import { Div } from '../../../base/components/native/div'
import { Redemption } from './redemption'

export const Redemptions = () => {

    const base = Div()
    const title = Div('سابقه استفاده از امتیاز')
    const list = Div()
    base.append(title, list)

    title.cssClass({
        fontSize: '18px',
    })
    base.cssClass({
        height: 'calc(100% - 250px)',
        overflow: 'auto',
    })

    return Object.assign(base, {
        async fill(redemptions: any[]) {
            list.empty()
            for (const redemption of redemptions) {
                const item = Redemption(redemption)
                list.append(item)
            }
        }
    })
}